module.exports = __webpack_public_path__ + "static/services-header-5c53ee6c1eb5b3446f914289da3b6130.jpg";